import http from "@/request/index.ts";

export default class CaseApi {
  /**
   * 获取客户案例接口
   */
  async getCaseList(data) {
    let res = await http.get("/case/list", data);
    return res.data;
  }

  /**
   * 获取客户案例详情
   */
  async getCaseDetail(params) {
    let res = await http.get("/case/" + params.id);
    return res.data;
  }

  /**
   * 获取客户案例浏览量
   */
  async addCaseBrowse(id) {
    let res = await http.get("/case/readNum/" + id);
    return res.data;
  }

  /**
   * 官网浏览案例保存接口
   */
  async setBrowse() {
    let res = await http.post("/view/save");
    return res.data;
  }

  /**
   * 案例浏览量增加
   */
  async addCaseBrowse(id) {
    let res = await http.post("/case/readNum/" + id);
    return res.data;
  }
}
